import { create } from 'zustand';

export enum DEMO_VIEW_MODE {
  DESKTOP = 'desktop',
  TABLET = 'tablet',
  MOBILE = 'mobile',
}

interface AddonsStore {
  viewMode: DEMO_VIEW_MODE;
  setViewMode: (viewMode: DEMO_VIEW_MODE) => void;
  showOthers: boolean;
  setShowOthers: (showOthers: boolean) => void;
  isHeaderVisible: boolean;
  setIsHeaderVisible: (showOthers: boolean) => void;
}

export const useProductDemoStore = create<AddonsStore>((set) => ({
  viewMode: DEMO_VIEW_MODE.DESKTOP,
  setViewMode: (viewMode: DEMO_VIEW_MODE) => set({ viewMode }),
  showOthers: false,
  setShowOthers: (showOthers: boolean) => set({ showOthers }),
  isHeaderVisible: true,
  setIsHeaderVisible: (isHeaderVisible: boolean) => set({ isHeaderVisible }),
}));
